import { AutoSplitCandidate } from "./auto_split_wizard_types"

interface AutoSplitReviewProps {
  candidates: AutoSplitCandidate[]
  transactionAmount: number
  warnings: string[]
}

export function AutoSplitReview({ candidates, transactionAmount, warnings }: AutoSplitReviewProps) {
  const total = candidates.reduce((sum, candidate) => sum + candidate.source_amount_cents, 0) / 100
  const expected = Math.round(Math.abs(transactionAmount) * 100) / 100

  return (
    <div class="space-y-4">
      <div class="grid grid-cols-1 gap-3 md:grid-cols-3">
        <div class="rounded-md border border-gray-200 bg-gray-50 p-4">
          <div class="text-sm text-gray-500">Candidate Splits</div>
          <div class="mt-1 text-2xl font-semibold">{candidates.length}</div>
        </div>
        <div class="rounded-md border border-gray-200 bg-gray-50 p-4">
          <div class="text-sm text-gray-500">Split Total</div>
          <div class="mt-1 text-2xl font-semibold">{total.toFixed(2)}</div>
        </div>
        <div class="rounded-md border border-gray-200 bg-gray-50 p-4">
          <div class="text-sm text-gray-500">Expected Amount</div>
          <div class="mt-1 text-2xl font-semibold">{expected.toFixed(2)}</div>
        </div>
      </div>

      {warnings.length > 0 ? (
        <div class="rounded-md border border-amber-200 bg-amber-50 p-4">
          <div class="mb-2 font-medium text-amber-900">Warnings</div>
          <div class="space-y-1.5 text-sm leading-relaxed text-amber-800">
            {warnings.map((warning: string, idx: number) => (
              <div key={`${idx}-${warning}`}>- {warning}</div>
            ))}
          </div>
        </div>
      ) : (
        <div class="rounded-md border border-green-200 bg-green-50 p-4 text-sm leading-relaxed text-green-900">
          No validation warnings detected.
        </div>
      )}

      <div class="space-y-2">
        {candidates.map((candidate: AutoSplitCandidate, index: number) => (
          <div key={candidate.id} class="rounded-md border border-gray-200 p-4 text-sm leading-relaxed">
            <div class="mb-1 font-medium">Split {index + 1}</div>
            <div class="text-gray-700">
              {candidate.retailer_name || "Unknown"} • {candidate.product_line || "Unknown"} •{" "}
              {candidate.product_category || "Unknown"}
            </div>
            <div class="mt-1 text-gray-500">{candidate.source_amount.toFixed(2)}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
